import 'swiper/css'
import 'swiper/css/navigation'

import React from 'react'

import { Swiper, SwiperSlide } from 'swiper/react'

import Button from './Button'
import Slide from './Slide'
import { Container } from './styles'

import { LearnSectionGalleryItem } from '../constants'

type Props = {
  items?: LearnSectionGalleryItem[]
}

function LearnSectionGalleryCarousel({ items }: Props) {
  if (!items) return null

  return (
    <Container>
      <Swiper centeredSlides grabCursor loop slidesPerView={3.3}>
        <Button />

        {items.map(item => (
          <SwiperSlide key={item.id}>
            <Slide item={item} />
          </SwiperSlide>
        ))}

        <Button isNext />
      </Swiper>
    </Container>
  )
}

export default LearnSectionGalleryCarousel
